import React from 'react';

import Category from 'components/Ui/Category';
import Subject from 'containers/Administrator/Grades/Profile/Reports/Subjects/Subject';

const Subjects = ({ subjects }) => {
	return (
		<Category title="Mācību kursi" hide>
			{subjects?.map(subject =>
				<Subject key={subject.id} subject={subject} />
			)}
		</Category>
	);
};

export default Subjects;